import { useContext, useState } from 'react';

import {
  MAX_MATURITY_DATE,
  MAX_ROI,
  MAX_YEAR_PROFIT,
  MIN_MATURITY_DATE,
  MIN_ROI,
  MIN_YEAR_PROFIT,
  SliderValue,
} from '../utils';
import { ProjectsContext } from '../views/dashboard/lender/investment/projects/ProjectsContext';
import { useEffectOnUpdate } from './useEffectOnUpdate';

export const useProjectsFilter = () => {
  const context = useContext(ProjectsContext);
  const [search, setSearch] = useState(context.filter.search);
  const [initialTermFrom, setInitialTermFrom] = useState(context.filter.initialTermFrom);
  const [initialTermTo, setInitialTermTo] = useState(context.filter.initialTermTo);
  const [interestRateFrom, setInterestRateFrom] = useState(context.filter.interestRateFrom);
  const [interestRateTo, setInterestRateTo] = useState(context.filter.interestRateTo);
  const [simpleInterestRateFrom, setSimpleInterestRateFrom] = useState(
    context.filter.simpleInterestRateFrom
  );
  const [simpleInterestRateTo, setSimpleInterestRateTo] = useState(
    context.filter.simpleInterestRateTo
  );
  const [statuses, setStatuses] = useState(context.filter.statuses);

  useEffectOnUpdate(() => {
    const filter = context.filter;
    setSearch(filter.search);
    setInitialTermFrom(filter.initialTermFrom);
    setInitialTermTo(filter.initialTermTo);
    setInterestRateFrom(filter.interestRateFrom);
    setInterestRateTo(filter.interestRateTo);
    setSimpleInterestRateFrom(filter.simpleInterestRateFrom);
    setSimpleInterestRateTo(filter.simpleInterestRateTo);
    setStatuses(filter.statuses);
  }, [context.filter]);

  const handleMaturityDateChange = (value: SliderValue) => {
    setInitialTermFrom(value.min === MIN_MATURITY_DATE ? null : value.min);
    setInitialTermTo(value.max === MAX_MATURITY_DATE ? null : value.max);
  };

  const handleYearProfitChange = (value: SliderValue) => {
    setInterestRateFrom(value.min === MIN_YEAR_PROFIT ? null : value.min);
    setInterestRateTo(value.max === MAX_YEAR_PROFIT ? null : value.max);
  };

  const handleRoiChange = (value: SliderValue) => {
    setSimpleInterestRateFrom(value.min === MIN_ROI ? null : value.min);
    setSimpleInterestRateTo(value.max === MAX_ROI ? null : value.max);
  };

  const handleSubmit = () => {
    context.setFilter({
      ...context.filter,
      search,
      initialTermFrom,
      initialTermTo,
      interestRateFrom,
      interestRateTo,
      simpleInterestRateFrom,
      simpleInterestRateTo,
    });
    context.toggleFilter();
  };

  return {
    search,
    setSearch,
    initialTermFrom,
    setInitialTermFrom,
    initialTermTo,
    setInitialTermTo,
    interestRateFrom,
    setInterestRateFrom,
    interestRateTo,
    setInterestRateTo,
    simpleInterestRateFrom,
    setSimpleInterestRateFrom,
    simpleInterestRateTo,
    setSimpleInterestRateTo,
    handleMaturityDateChange,
    handleYearProfitChange,
    handleRoiChange,
    handleSubmit,
    statuses,
    setStatuses,
  };
};

export default useProjectsFilter;
